MdTooltipDirective.$inject = ["$$rAF", "$mdUtil", "$window"];
export function MdTooltipDirective($$rAF, $mdUtil, $window) {
    "ngInject"

    var TOOLTIP_SHOW_DELAY_IN = 100;
    var TOOLTIP_SHOW_DELAY_OUT = 100;
    var TOOLTIP_WINDOW_EDGE_SPACE = 8;
    var TOOLTIP_ARROW_SPACE = 8;
    return {
        restrict: 'E',
        transclude: true,
        priority: 210, // Before ngAria
        template: '<div class="" ng-transclude></div>',
        scope: {
            delayIn: '=?mdDelayIn',
            delayOut: '=?mdDelayOut',
            visible: '=?mdVisible',
            autohide: '=?mdAutohide',
            direction: '@?mdDirection' // only expect raw or interpolated string value; not expression
        },
        compile: function (tElement, tAttr) {
            if (!tAttr.mdDirection) {
                tAttr.$set('mdDirection', 'top');
            }

            return postLink
        }
    };

    function postLink(scope, element, attr) {



        var tooltipSize,
            parentOffset,
            tooltipOffset,
            tooltipPosition,
            parent = $mdUtil.getParentWithPointerEvents(element);

        setTimeout(function () {
            tooltipSize = { width: element.width(), height: element.height() }
            parentOffset = $('.has-tooltip').offset();
            tooltipOffset = parent.offset();
            tooltipPosition = { left: tooltipOffset.left - parentOffset.left - tooltipSize.width - TOOLTIP_ARROW_SPACE, top: tooltipOffset.top - parentOffset.top - (tooltipSize.height / 4) }
            element.detach();
            configureWatchers()
        }, 800)

        angular.element($window).bind('resize', function () {
            // tooltipSize = {width:element.width(),height:element.height()}
            parentOffset = $('.has-tooltip').offset();
            tooltipOffset = parent.offset();
            tooltipPosition = { left: tooltipOffset.left - parentOffset.left - tooltipSize.width - TOOLTIP_ARROW_SPACE, top: tooltipOffset.top - parentOffset.top - (tooltipSize.height / 4) }
        })

        setDefaults();



        function setDefaults() {
            scope.delayIn = scope.delayIn || TOOLTIP_SHOW_DELAY_IN;
            scope.delayOut = scope.delayOut || TOOLTIP_SHOW_DELAY_OUT;
        }



        function configureWatchers() {
            var mEnter, mLeave, detach;
            parent.on('mouseenter', function () {
                clearTimeout(detach);
                clearTimeout(mLeave);
                mEnter = setTimeout(function () {
                    if (element.hasClass('fadeIn')) {

                    }
                    else {
                        $('.has-tooltip').append(element);
                        element.addClass('animated')
                        element.removeClass('fadeOut')
                        element.addClass('fadeIn')

                        element.css({ top: tooltipPosition.top, left: tooltipPosition.left })
                    }
                }, scope.delayIn)
            })

            parent.on('mouseleave', function () {
                mLeave = setTimeout(function () {
                    clearTimeout(mEnter);
                    element.removeClass('fadeIn')
                    element.addClass('fadeOut')
                    detach = setTimeout(function () {
                        element.removeClass('fadeOut')
                        element.detach()
                    }, 1000)
                }, scope.delayOut)
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/directives/ecbTooltip/ecbTooltip.ts